import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 space-y-1"
}
const _hoisted_2 = { class: "font-bold text-gray-900" }
const _hoisted_3 = { class: "divide-y" }
const _hoisted_4 = { class: "text-gray-iron-600" }
const _hoisted_5 = { class: "max-w-md font-medium text-gray-900" }
const _hoisted_6 = { class: "font-bold text-gray-900" }
const _hoisted_7 = { class: "divide-y" }
const _hoisted_8 = { class: "text-gray-iron-600" }
const _hoisted_9 = { class: "max-w-md font-medium text-gray-900" }

import { ref, computed } from 'vue';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

import type { Product, ProductOption } from '../utils/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductOverview',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const activePanels = ref<string | null>(null);

const hasValidValue = (option: ProductOption): boolean => {
  return option.value !== null && option.value !== 'BRAK' && option.value !== '';
};

const isEmptyProduct = (productName: string | undefined): boolean => {
  if (!productName) return true;
  const normalizedName = productName.toLowerCase().trim();
  return normalizedName === 'brak' || normalizedName === '' || normalizedName.includes('brak');
};

const hasValidMainOptions = computed(() => {
  if (!props.product) return false;
  if (isEmptyProduct(props.product.name)) return false;
  return props.product.product_options?.some(hasValidValue) ?? false;
});

const validProductGroups = computed(() => {
  return (
    props.product?.product_groups?.filter((group) => {
      if (isEmptyProduct(group.product?.name)) return false;
      return group.product?.product_options?.some(hasValidValue);
    }) ?? []
  );
});

const shouldShowAccordion = computed(() => {
  return hasValidMainOptions.value || validProductGroups.value.length > 0;
});

return (_ctx: any,_cache: any) => {
  return (shouldShowAccordion.value)
    ? (_openBlock(), _createBlock(_unref(Accordion), {
        key: 0,
        class: "mt-6",
        value: activePanels.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((activePanels).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AccordionPanel), { value: "parameters" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AccordionHeader), null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Parametry")
                ])),
                _: 1
              }),
              _createVNode(_unref(AccordionContent), { class: "space-y-6" }, {
                default: _withCtx(() => [
                  (_ctx.product?.product_options?.length)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
                        _createElementVNode("header", _hoisted_2, "Parametry " + _toDisplayString(_ctx.product.name), 1),
                        _createElementVNode("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product?.product_options, (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option.id,
                              class: "flex justify-between py-3 text-sm"
                            }, [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(option.name), 1),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(option.value), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product?.product_groups.filter(
            (group) => group.product?.product_options?.length
          ), (group) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: group.id,
                      class: "mt-4 space-y-1"
                    }, [
                      _createElementVNode("header", _hoisted_6, "Parametry " + _toDisplayString(group.product.name), 1),
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.product.product_options, (option) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: option.id,
                            class: "flex justify-between py-3 text-sm"
                          }, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(option.name), 1),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(option.value), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]))
    : _createCommentVNode("", true)
}
}

})